import React from "react";
import whiteYellow from "../../assets/whiteYellow.svg";
import openMouthImg from "../../assets/openMouth.svg";
import girlBookImg from "../../assets/girlwithbook.svg";
import girlImg from "../../assets/girlChild4.svg";
import rainbowImg from "../../assets/cloudRainbow.svg";
import MarkerImg from "../../assets/childwithmarker.svg";
import girlChildImg from "../../assets/girlHead.svg";

const InteractiveGallery = () => {
  return (
    <div className="ml-[2.6%] mt-[50px] grid relative overflow-hidden">
      <div className="absolute w-[full] h-full bottom-[-90%] lg:block hidden sm:bottom-0 sm:top-[20%] -right-[17.5%] overflow-hidden ">
        <img
          src={girlImg}
          layout="fit"
          width={1400}
          height={600}
          alt="girlchild4"
        />
      </div>
      <p
        className={
          " font-Wonderbar sm:px-0 px-[5%] text-[#D31C4F] leading-10 lg:leading-[4rem] text-[34px] sm:text-[4rem] "
        }
      >
        Our Interactive{" "}
        <span className="text-[26px] sm:text-[44px]">Gallery</span>
      </p>
      <div className=" flex gap-[2rem]  lg:mt-[5rem] relative lg:w-[75%]">
        {/* <div className="absolute lg:-top-[18%] left-[6%] lg:left-[0%] z-10">
              <img src="/crazyEyes.gif" alt="crazyEyes" />
            </div> */}

        {/* animation div */}
        <div className="grid lg:mt-0 mt-[20px] sm:mt-[100px] grid-cols-1 sm:grid-cols-2 lg:grid-cols-4  lg:flex lg:h-[32.5rem] gap-[1rem] w-[100%] galleryCards">
          <div
            className="h-[25rem] min-w-[250px] lg:h-[32.5rem] bg-[#b1d4ff] rounded-[3rem] relative p-[2rem] cursor-pointer"
            onClick={() => window.open("/interactiveGallery", "_self")}
          >
            <p
              className={
                "text-[2rem] lg:text-[2rem] w-[100%] text-white !font-extrabold "
              }
            >
              Fun , Play & Adventure
            </p>
            <button
              className={
                "text-base lg:text-[1.5rem] text-[#d31c3e] bg-white rounded-xl lg:py-[0.5rem] py-[2px] px-4 lg:px-[1.5rem] mt-[3rem] lg:mt-[2rem] "
              }
            >
              1.6 million streams
            </button>
            <p className="absolute w-[80%] h-1/2 left-[2%] ">
              <img
                src={rainbowImg}
                layout="fill"
                className="object-fit pt-4 ml-[10%] mt-[10%]  h-[100px] lg:ml-[10%]  lg:h-[175px]"
                alt="rainbow"
              />
            </p>
          </div>
          <div
            className=" h-[25rem] pb-[20px] lg:h-full  bg-[#ffabc3] rounded-[3rem] cursor-pointer"
            onClick={() => window.open("/interactiveGallery", "_self")}
          >
            <p
              className={
                "text-[2.1rem] w-[80%] text-white !font-extrabold m-[5%] lg:m-[10%] "
              }
            >
              Kids & <span>Gallery</span>
            </p>
            <div className="h-[100px] lg:h-2/3 mt-[50px] relative flex flex-col">
              <div className="relative ">
                <img
                  src={whiteYellow}
                  layout="fit"
                  className="absolute lg:top-[-90px] sm:top-[-34px] left-[2%] lg:left-[20%]  lg:h-[180px] lg:w-[130px] w-[180px] h-[50px]"
                  alt="whiteYellow"
                />
                <img
                  src={openMouthImg}
                  layout="fit"
                  className="absolute right-[2%] lg:right-[40%] top-[-35px] lg:top-0 lg:h-[180px] lg:w-[100px] h-[100px] w-[80px]"
                  alt="openMouth"
                />
                <div className="flex items-center justify-center space-x-2 absolute top-[-100px] lg:top-[155px] font-gliker text-[#0C99B4] -rotate-[45deg]   ">
                  <span className="text-[2.4rem] font-bold">M</span>
                  <span className="text-[1.6rem] font-bold">A,</span>
                  <span className="text-[1.3rem] font-bold">P</span>
                  <span className="text-[0.8rem] font-bold">A</span>
                </div>
                <img
                  src={girlChildImg}
                  layout="fit"
                  className="absolute top-[90px] lg:top-[180px] lg:h-[180px] lg:w-[90px] h-[100px] w-[80px]"
                  alt="girlChild"
                />
              </div>
            </div>
          </div>
          <div
            className=" h-[25rem] lg:h-full bg-[#ffe7c4] rounded-[3rem] cursor-pointer"
            onClick={() => window.open("/activities", "_self")}
          >
            <p
              className={
                "text-[2.1rem] w-[70%] text-white !font-extrabold m-[8%] lg:m-[10%] "
              }
            >
              Games & Activities
            </p>
            <div>
              <div className="ml-[10%]">
                <img
                  src={MarkerImg}
                  layout="fit"
                  className="lg:h-[280px] lg:w-[215px] h-[180px]"
                  alt="childwithmarker"
                />
              </div>
            </div>
          </div>
          <div
            className=" h-[25rem] lg:mb-0 mb-[30px]  lg:h-full bg-[#c0f4ff] rounded-[3rem] cursor-pointer"
            onClick={() => window.open("/about#awards", "_self")}
          >
            <p
              className={
                "text-[2.1rem] w-[80%] text-white !font-extrabold m-[10%] "
              }
            >
              Awards & Campaigns
            </p>
            <div className="relative">
              <img
                src={girlBookImg}
                layout="fit"
                alt="girlwithbook"
                className="absolute lg:top-[100px] left-[8%] h-[150px] lg:h-[200px] w-[220px]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InteractiveGallery;
